import _default from './TextArea';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/TextArea/index.js
// module id = 469
// module chunks = 0